export default __webpack_public_path__ + "static/media/thumbnail_image_4.0abe6956.png";